import React from 'react';

const CountryFlag = React.memo(({ isoCode }: { isoCode: string }) => {
  const [src, setState] = React.useState('');
  import(`../../assets/flagsIso3/${isoCode}.svg`).then((res) => {
    setState(res.default);
  });
  return src ? <img alt="Country flag icon" src={src} /> : null;
});
CountryFlag.displayName = 'CountryFlag';

export default CountryFlag;
